window.onscroll = scrolled;

function scrolled() {
	if (document.querySelector("recently-viewed-popup")) {
		document.querySelector("recently-viewed-popup").style.display = "none";
	}
}

const onScrollStop = callback => {
	let isScrolling;
	window.addEventListener(
		'scroll',
		e => {
			clearTimeout(isScrolling);
			isScrolling = setTimeout(() => {
				callback();
			}, 150);
		},
		false
	);
};

onScrollStop(() => {
	if (document.querySelector("recently-viewed-popup")) {
		document.querySelector("recently-viewed-popup").style.display = "block";
	}
});

customElements.define('customer-reset-password', class extends HTMLElement {
	constructor() {
		super();

		this.handlePasswordInputValidation = this.handlePasswordInputValidation.bind(this);
		this.passwordInput = this.querySelector('#password');
		this.passwordConfirmInput = this.querySelector('#password_confirmation');
		this.submitBtn = this.querySelector('button[type="button"]');

		this.submitBtn.addEventListener('click', (e) => {

			const { errorMsg: passwordError } = this.handlePasswordInputValidation();
			const { errorMsg: passwordConfirmError } = this.handlePasswordConfirmInputValidation();
			const passwordInputError = this.querySelector('#password-error');
			const passwordConfirmInputError = this.querySelector('#password-confirmation-error');

			let hasError = !!passwordError || !!passwordConfirmError || false;

			passwordInputError.classList.toggle('d-block', passwordError);
			passwordInputError.querySelector(".ap-form-field-error-content").innerHTML = passwordError ? passwordError : '';

			passwordConfirmInputError.classList.toggle('d-block', passwordConfirmError);
			passwordConfirmInputError.querySelector(".ap-form-field-error-content").innerHTML = passwordConfirmError ? passwordConfirmError : '';

			if (!hasError) {
				this.querySelector('form').submit();
			}
		})
	}

	handlePasswordInputValidation() {
		const passwordValue = this.passwordInput.value;
		let errorMsg = '';
		if (!passwordValue) {
			errorMsg = 'Password can\'t be blank.';
		} else if (passwordValue.length < 8) {
			errorMsg = 'The password is too short';
		} else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/.test(passwordValue)) {
			errorMsg = 'Password rules: Uppercase + Lowercase + Number + Special Characters (8 or more characters)';
		}

		return {
			errorMsg
		}
	}

	handlePasswordConfirmInputValidation() {
		const passwordValue = this.passwordInput.value;
		const passwordConfirmValue = this.passwordConfirmInput.value;
		let errorMsg = '';

		if (!passwordConfirmValue) {
			errorMsg = 'Password confirmation can\'t be blank.';
		} else if (passwordConfirmValue && passwordValue !== passwordConfirmValue) {
			errorMsg = 'Password does not match, please re-enter.';
		}

		return {
			errorMsg
		}
	}
})

customElements.define('customer-login', class extends HTMLElement {
	constructor() {
		super();
		this.handleChangeTitle = this.handleChangeTitle.bind(this);
	}

	connectedCallback() {
		/* 입력영역 타이틀 공통 */
		$(".MembershiploginWrap .input-box .form-field-container input").focus(function () {
			$(this)
				.parents(".input-box")
				.children("div.form-field-container")
				.addClass("focus");
		});
		$(".MembershiploginWrap .input-box .form-field-container input").blur(function () {
			if (!$(this).val()) {
				$(this)
					.parents(".input-box")
					.children("div.form-field-container")
					.removeClass("focus");
			}
		});

		$("#email").focus(function () {
			if ($("#error-email").css("display") !== "none") {
				$("#error-email").hide();
			}
		});

		$("#password").focus(function () {
			if ($("#error-password").css("display") !== "none") {
				$("#error-password").hide();
			}
		});

		this.handleChangeTitle();
	}

	handleChangeTitle() {
		const ELM_trigger = this.querySelector('#recover-trigger');
		const cb = () => {
			const ELM_title = this.querySelector('h1');
			ELM_title.innerHTML = ELM_title.getAttribute("data-recover-header");
		}
		if (location.href.indexOf('recover') > -1) {
			cb();
		}
		ELM_trigger.addEventListener('click', cb);
		window.addEventListener('popstate', (e) => {
			if (location.href.indexOf('recover') > -1) {
				cb();
			} else {
				const ELM_title = this.querySelector('h1');
				ELM_title.innerHTML = ELM_title.getAttribute("data-login-header");
			}
		})
	}
})